<template>
  <div>
    <br />
    <div id="tableTitle">
      <p id="title">{{ $t('PEER.ResultTable.ResultDetail.title') + title }}</p>
      <p id="responseRate">{{ $t('PEER.ResultTable.ResultDetail.responseRate') + responseRate }}</p>
      <p id="createdAt">{{ $t('PEER.ResultTable.ResultDetail.createdAt') + createdAt }}</p>
    </div>
    <TabulatorComponent v-model="papersDetail" :options="options" id="ResultDetailTable" />
    <br />
    <br />
  </div>
</template>

<script>
import { TabulatorComponent } from 'vue-tabulator';
import { getPaperDetailData } from '@/api/evaluationPaper';

export default {
  name: 'ResultDetailTable',
  components: {
    TabulatorComponent,
  },
  props: {
    selectedResultId: { type: Number, default: 0 },
  },
  methods: {
    getMergedData(response) {
      let mergedDataList = [];

      const questionLength = response.evaluationPaper.questions.length;
      for (let questionNum = 0; questionNum < questionLength; questionNum += 1) {
        const answers = response.evaluationPaper.questions[questionNum].answers;
        const answerLength = answers.length;

        for (let answerNum = 0; answerNum < answerLength; answerNum += 1) {
          const question = { questions: questionNum + 1 };
          const answer = answers[answerNum];
          const mergedData = Object.assign({}, question, answer);
          mergedDataList.push(mergedData);
        }
      }

      return mergedDataList;
    },
    convertToDate(milliseconds) {
      const createdDateObj = new Date(milliseconds);
      const createdDate = createdDateObj.toLocaleDateString();
      return createdDate;
    },
    formatPercentageData(mergedData) {
      const paperLength = mergedData.length;
      for (let i = 0; i < paperLength; i++) {
        mergedData[i].percentage = `${mergedData[i].percentage.toFixed(2)}%`;
      }
    },
  },
  created() {
    getPaperDetailData(this.selectedResultId).then((response) => {
      const milliseconds = response.evaluationPaper.createdAt;
      this.title = response.evaluationPaper.title;
      this.responseRate =
        (
          response.evaluationPaper.currentNumberOfReviewers /
          response.evaluationPaper.totalNumberOfReviewers
        ).toFixed(2) *
          100 +
        '%';
      this.createdAt = this.convertToDate(milliseconds);
      let mergedData = this.getMergedData(response);
      this.formatPercentageData(mergedData);
      this.papersDetail = mergedData;

      const rawData = response.evaluationPaper;
      this.$emit('updateRawData', rawData);
    });
  },
  data() {
    return {
      title: '',
      responseRate: '',
      createdAt: '',
      papersDetail: [],
      options: {
        groupBy: 'questions',
        height: '700px',
        columns: [
          {
            title: this.$i18n.locale === 'eng' ? 'index' : '문항',
            field: 'questions',
            sorter: 'number',
            width: 100,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'email' : '이메일',
            field: 'email',
            sorter: 'string',
            width: 200,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'response' : '문항 응답',
            field: 'content',
            sorter: 'string',
            width: 350,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'score' : '점수',
            field: 'averageScore',
            sorter: 'number',
            width: 100,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'ranking' : '등수',
            field: 'ranking',
            sorter: 'number',
            width: 100,
          },
          {
            title: this.$i18n.locale === 'eng' ? '%' : '백분율',
            field: 'percentage',
            sorter: 'string',
            width: 100,
          },
        ],
      },
    };
  },
  watch: {
    '$i18n.locale': function (newLocale, oldLocale) {
      this.options.columns[0].title = newLocale === 'eng' ? 'index' : '문항';
      this.options.columns[1].title = newLocale === 'eng' ? 'email' : '이메일';
      this.options.columns[2].title = newLocale === 'eng' ? 'response' : '문항 응답';
      this.options.columns[3].title = newLocale === 'eng' ? 'score' : '점수';
      this.options.columns[4].title = newLocale === 'eng' ? 'ranking' : '등수';
      this.options.columns[5].title = newLocale === 'eng' ? '%' : '백분율';
    },
  },
};
</script>

<style lang="scss">
#tableTitle {
  border-left: 1.5px solid $MAIN-COLOR;
  border-right: 1.5px solid $MAIN-COLOR;
  border-top: 2px solid $MAIN-COLOR;
  border-bottom: 2px solid $MAIN-COLOR;
  border-radius: 5px;
  margin-top: 20px;

  P {
    width: 33.33%;
    text-align: center;
    display: inline-block;
    padding: 10px 0px;
    font-size: 1rem;
    font-weight: bold;
  }
}

#ResultDetailTable {
  box-sizing: border-box;
  max-width: 1200px;
  max-height: none;
  margin: 30px auto 0px auto;
  border-top: 2px solid $MAIN-COLOR;
  border-bottom: 2px solid $MAIN-COLOR;
  border-collapse: collapse;
  table-layout: fixed;

  .tabulator-table {
    width: 100%;
  }

  .tabulator-header {
    border-bottom: 2px solid $MAIN-COLOR;
    border-top: none;
  }

  .tabulator-col.tabulator-sortable {
    background-color: #f4f3ef;
  }

  .tabulator-row-odd,
  .tabulator-row-even {
    background-color: #f4f3ef;
  }

  .tabulator-group-level-0.tabulator-row-odd,
  .tabulator-group-level-0.tabulator-row-even {
    text-align: left;
    padding-left: 100px;
    display: flex;
    line-height: 30px;
    font-size: 1rem;
  }

  .tabulator-group-visible {
    background-color: #c5d2ed;
    text-align: left;
    padding-left: 100px;
    display: flex;
    line-height: 30px;
    font-size: 1rem;
  }
}

@media (max-width: 992px) {
  #ResultTable {
    width: 100%;
  }
}
</style>
